import React from 'react'
import TableRow from './TableRow';

const MessageTableBody = ({ item }) => {
    const { SNo, tempID, msgType, msg, action } = item;
    return (
        <>
            <tr className="tableborder hover:bg-gray-200">
                <TableRow
                    tableTitle={SNo}
                />
                <TableRow
                    tableTitle={tempID}
                />
                <TableRow
                    tableTitle={msgType}
                />
                <TableRow
                    tableTitle={msg}
                />
                <TableRow
                    tableTitle={action}
                />
            </tr>
        </>
    )
}

export default MessageTableBody
